<template>
  <div class="" style="margin:0">
    <v-row  no-gutters  class="main-view ">
        <v-col cols="12" xl="5" lg="5" class="">
              
               <v-row align="center" class="pa-5" justify="center" no-gutters dense>
                   
                   <v-combobox
                   class="pt-5 text-caption"
          v-model="select"
          :items="gem"
          item-value="properties.PROPERTY_NAME_TEXT"
            @input="selecting"
            placeholder="Filter Apartments"
          item-text="properties.PROPERTY_NAME_TEXT"
           
            @click:clear="nselect=''"
            clearable
          outlined
          dense
        ></v-combobox>
                        

                <v-btn class="ml-2" style="text-transform:none " rounded outlined>Filter</v-btn>
                
               </v-row>
             
               <List  :item="filteredRecipes" />
        </v-col>
        <v-col   cols="12" xl="7" lg="7">
            <Esri :center="newCenter" :item="filteredRecipes" />
        </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import Esri from '../components/ESRI.vue'
import List from '../components/List.vue'
export default {
    components:{
        Esri,
        List
    },
    data(){
        return {
            color:'white',
            item:[],
            mitem:[{lng:-49.97,lat:41.73},{lng:-59.97,lat:51.73}],
            gem:[],
            ngem:[],
            select:"",
            nselect:'',
            center:[-97.7431, 30.2672],
            ncenter:this.center,
            nn:false
        
        }
    },
    beforeCreate(){
        
         axios.get('https://housingapi.herokuapp.com/data').then(res=>{
            this.item=res.data
          for(var i=0;i<res.data.length;i++){
             if(res.data[i].properties.STD_ST=='TX'){
                  this.gem.push(res.data[i])
             }
          }
            console.log(res.data)
            this.ngem=this.gem
        }).catch(err=>{
            console.log(err)
        })
    },
    methods:{
        selecting(){
            this.nselect=this.select.properties.PROPERTY_NAME_TEXT
            this.ncenter=[this.select.geometry.coordinates[0],this.select.geometry.coordinates[1]]
        }
    },
    computed: {
        newCenter(){
 
          
          return this.center
        },
  filteredRecipes() {
    //   alert('hello')
    let tempRecipes = this.gem
    
   if(this.nselect==""){
        tempRecipes = tempRecipes.filter((item) => {
      return (item.properties.PROPERTY_NAME_TEXT !== this.nselect)
    })
   }else{
        tempRecipes = tempRecipes.filter((item) => {
      return (item.properties.PROPERTY_NAME_TEXT === this.nselect)
    })
   }
    
    return tempRecipes;
  }
},
    mounted(){
       
    }
}
</script>

<style>
.main-view{
    max-height: 90vh;
    width: 100%;
    font-family: 'Roboto', sans-serif;
}
::-webkit-scrollbar {
   
}

</style>